import { createBrowserRouter, Link } from "react-router-dom";
import notfound from "../assets/404.png";
import App from "../App";
import MainLayout from "../Layouts/MainLayout";
import ManageSellNotices from "../components/Notice/Manage/ManageSellNotices";
import NewNotice2 from "../components/Notice/NewNotice2";
import Profile from "../components/Profiles/profile";
import RegisterCompany from "../components/Company/RegisterCompany";
import Notice7 from "../components/Notice/Notice7";
import Chat2 from "../components/messaging/Chat2";
import ForgetPassword from "../components/account/ForgetPassword";
import CheckPhoneNumber from "../components/account/CheckPhoneNumber";
import ConfirmForgetPassword from "../components/account/ConfirmForgetPassword";
import RolesList from "../components/admin/roles/rolesList";
import EditAccess from "../components/admin/access/editAccess";
import Companies from "../components/Company/Companies";
import ManagePosition from "../components/position/ManagePosition";
import ViewInvitation from "../components/invitation/ViewInvitation";
import InvitationRequest from "../components/invitation/InvitationRequest";
import InvitationPassword from "../components/invitation/InvitationPassword";
import InvitationRequestConfirmUser from "../components/invitation/InvitationRequestConfirmUser";
import InvitationNotFound from "../components/invitation/InvitationNotFound";
import CompaniesView from "../components/Company/CompaniesView";
import InvitationRequestCheck from "../components/invitation/InvitationRequestCheck";
import CompareTableNoticeDetailsVer1 from "../components/reports/CompareTableNoticeDetailsVer1";
import CompareTableReportVer2 from "../components/reports/CompareTableReportVer2";
import Positions2 from "../components/position/Positions2";
import RegisterV2 from "../components/account/RegisterV2";
import PersonelInvitationView from "../components/invitation/PersonelInvitationView";
import LoginV2 from "../components/account/LoginV2";
import AcceleratorManagement from "../components/Notice/Accelerator/AcceleratorManagement";
import ManageNoticeV3 from "../components/Notice/Manage/ManageNoticeV3";
import CompanyInvitationsV2 from "../components/invitation/CompanyInvitationsV2";
import CompanyInfo from "../components/Company/CompanyInfo";
import CollabratingCompany from "../components/companyGeneral/CollabratingCompany";
import MainDashboard from "../components/general/MainDashboard";
import NoticeContainer from "../components/Notice/NoticeContainer";
import Notice8 from "../components/Notice/Notice8";
import UserInfo from "../components/User/UserInfo";
import NoticeTabs from "../components/Notice/NoticeTabs";
import NoticePrice from "../components/Notice/NoticePrice";
import RecivedAccelerators from "../components/Notice/Accelerator/RecivedAccelerators";
import NoticeView from "../components/Notice/NoticeView";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <MainLayout />,
    errorElement: (
      <>
        <div style={{ textAlign: "center" }} className="col-12">
          <img sizes="700px" width="700px" src={notfound} />
        </div>
        <div style={{ textAlign: "center" }} className="col-12">
          <Link to={"/"}>بازگشت به صفحه اصلی</Link>
        </div>
      </>
    ),
    children: [
      {
        path: "/Register",
        element: <RegisterV2 />,
        children: [],
      },
      {
        path: "/Login",
        element: <LoginV2 />,
        children: [],
      },
      {
        path: "/iframe/notice/:id",
        element: <Notice7 />,
        children: [],
      },
      {
        path: "/reg/acc",
        element: <RegisterV2 />,
        children: [],
      },
      {
        path: "/iframe/report",
        element: <CompareTableReportVer2 />,
        children: [],
      },
      {
        path: "/iframe/reportNoticeDetails",
        element: <CompareTableNoticeDetailsVer1 />,
        children: [],
      },

      {
        path: "/",
        element: <App />,
        children: [
          {
            path: "/",
            element: <NoticeContainer />,
            children: [
              {
                path: "/notice/:id",
                element: <Notice8 />,
                children: [],
              },
            ],
          },
          {
            path: "/AcceleratorManagement",
            element: <AcceleratorManagement />,
            children: [],
          },
          {
            path: "/Profile",
            element: <Profile />,
            children: [],
          },
          {
            path: "/Companies",
            element: <CompaniesView />,
            children: [],
          },
          {
            path: "/UserInfo",
            element: <UserInfo />,
            children: [],
          },
          {
            path: "/CompanyInfo",
            element: <CompanyInfo />,
            children: [
              {
                path: "/CompanyInfo/Positions",
                element: <Positions2 />,
                children: [
                  {
                    path: "/CompanyInfo/Positions/Manage/:id",
                    element: <ManagePosition />,
                    children: [],
                  },
                  {
                    path: "Manage/:flag/:id",
                    element: <ManagePosition />,
                    children: [],
                  },
                ],
              },
            ],
          },

          {
            path: "/Account",
            element: <RegisterV2 />,
            children: [],
          },

          {
            path: "/ForgetPassword",
            element: <ForgetPassword />,
            children: [
              {
                path: "/ForgetPassword/CheckPhoneNumber",
                element: <CheckPhoneNumber />,
                children: [],
              },
              {
                path: "/ForgetPassword/ChangePassword",
                element: <ConfirmForgetPassword />,
                children: [],
              },
            ],
          },
          {
            path: "/mainDashboard",
            element: <MainDashboard />,
            children: [],
          },

          {
            path: "/chat",
            element: <Chat2 />,
            children: [],
          },

          {
            path: "/chat/:id",
            element: <Chat2 />,
            children: [],
          },
          {
            path: "/chat/:id/:is",
            element: <Chat2 />,
            children: [],
          },

          {
            path: "/manageSellNotices",
            element: <ManageSellNotices />,
            children: [],
          },
          {
            path: "/CollabratingCompanies",
            element: <CollabratingCompany />,
            children: [],
          },

          {
            path: "/Feed",
            element: <NoticeContainer />,
            children: [],
          },
          {
            path: "/companies",
            element: <Companies />,
            children: [],
          },
          {
            path: "/newCompany",
            element: <RegisterCompany />,
            children: [],
          },
          {
            path: "/Dashboard",
            element: <NoticeTabs />,
            children: [
              {
                path: "/Dashboard/NoticeOffers/:id",
                element: <NoticePrice />,
                children: [],
              },
            ],
          },
          {
            path: "/NewNotice",
            element: <NewNotice2 />,
            children: [],
          },
          {
            path: "/ManageNotice",
            element: <ManageNoticeV3 />,
            children: [],
          },

          {
            path: "/ManageNotice/:id",
            element: <ManageNoticeV3 />,
            children: [],
          },
          {
            path: "InvitationNotFound",
            element: <InvitationNotFound />,
            children: [],
          },
          {
            path: "ViewInvitation",
            element: <ViewInvitation />,
            children: [
              {
                path: "InvitationRequestCheck",
                element: <InvitationRequestCheck />,
                children: [],
              },
              {
                path: "InvitationRequest/:id",
                element: <InvitationRequest />,
                children: [],
              },
              {
                path: "InvitationPassword/:id",
                element: <InvitationPassword />,
                children: [],
              },
              {
                path: "InvitationRequestConfirmUser/:id",
                element: <InvitationRequestConfirmUser />,
                children: [],
              },
            ],
          },

          {
            path: "Profile",
            element: <Profile />,
            children: [],
          },
          {
            path: "CompanyInvitationsV2",
            element: <CompanyInvitationsV2 />,
            children: [],
          },
          {
            path: "CompanyInvitations",
            element: <CompanyInvitationsV2 />,
            children: [],
          },
          {
            path: "PersonnelInvitations",
            element: <PersonelInvitationView />,
            children: [],
          },
          {
            path: "/positions",
            element: <Positions2 />,
            children: [],
          },

          {
            path: "/RolesList",
            element: <RolesList />,
            children: [],
          },
          {
            path: "/EditAccess",
            element: <EditAccess />,
            children: [],
          },
        ],
      },
    ],
  },
]);
